import { getLanguageFlag } from "../../../basic/flagIcon/FlagIcon";

interface LanguageFlagProps {
    languageName: string;
}

/** The language's flag, filling its container. */
const LanguageFlag = (props: LanguageFlagProps) => {
    const Flag = getLanguageFlag(props.languageName).flag;

    return (
        <Flag
            aria-hidden="true"
            className="size-full"
            preserveAspectRatio="xMidYMid slice"
        />
    );
};

export default LanguageFlag;
